import React from "react";
import "./Monard1.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card.jsx";
import Monard8images from "../../../Media/BSD/Armont/Monard/Monard8.js";
import Monard9images from "../../../Media/BSD/Armont/Monard/Monard9.js";

const imageMap = {
  Monard8images,
  Monard9images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="armont" className="produk">
      <h1>Welcome to Monard</h1>
      <h2>Cicilan Start 21 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
